import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import "./CustomModal.css";
import { icon } from "@fortawesome/fontawesome-svg-core";

interface CustomModalProps {
  modalIsOpen: boolean;
  handleClose: () => void;
  title: string;
  additionalTitle?: JSX.Element;
  body: string;
  bodyElement?: any;
  buttons?: Array<{
    label: string;
    onClick: () => void;
    type?: string;
    isSubmit?: boolean;
    buttonClassName?: any;
    icon?: JSX.Element;
  }> | null;
  id?: string;
  customClassName?: any;
  style?: any;
}

const CustomModal: React.FC<CustomModalProps> = ({
  modalIsOpen,
  handleClose,
  title,
  body,
  buttons,
  bodyElement,
  id,
  additionalTitle,
  customClassName = "",
  style,
}) => {
  const [t] = useTranslation();
  return (
    <Modal
      show={modalIsOpen}
      backdrop="static"
      keyboard={false}
      onHide={handleClose}
      centered={true}
      id={id}
      style={style}
      dialogClassName={`modal-100w-100h ${customClassName}`} // Custom class for full width and height
    >
      {t(title) && (
        <Modal.Header style={{ padding: "10px 20px" }} closeButton>
          <Modal.Title
            style={{ color: "var(--eec-red-color)" }}
            className="fw-bold h5"
          >
            {t(title)} <br />
            {additionalTitle}
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body
        style={{
          padding: "15px",
          borderBottom: "none",
        }}
        className="d-flex flex-column"
      >
        {body && <h5>{t(body)}</h5>}
        {bodyElement}
      </Modal.Body>

      {buttons && buttons.length > 0 && (
        <Modal.Footer>
          {buttons?.map((button, index) => (
            <button
              key={index}
              className={
                button.type
                  ? `btn btn-${button.type} ${button.buttonClassName}`
                  : `btn btn-outline-danger ${button.buttonClassName}`}
              onClick={button.onClick}
              type={button.isSubmit ? "submit" : undefined}
            >
              {button.icon ? <>{button.icon}&nbsp;&nbsp;&nbsp;</> : null}{t(button.label)}
            </button>
          ))}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
